import COLORS from 'theme/colors';
import { Box, Flex, Text, Input, customStyled, Switch } from '@mafc/trolly';
import FONTFAMILY from 'theme/fontFamily';

export const LoyaltyPointWrapper = customStyled(Box)`
  font-family: ${FONTFAMILY.PRIMARY};
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.LIGHT_BORDER};
  border-radius: 8px;
  padding: 12px 18px;
`;

export const LoyaltyPointHeader = customStyled(Flex)`
  color: ${COLORS.BLACK};
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

export const LoyaltyPointAvailable = customStyled(Flex)`
  color: ${COLORS.BLACK}
  font-size: 14px;
  line-height: 20px;
  margin-left: 4px;
`;

export const LoyaltyPointAvailableRow = customStyled(Flex)`
  color: ${COLORS.BLACK};
  align-items: center;
`;

export const MinimumPointsMessage = customStyled(Text)`
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  margin: 12px 0;
  color: ${COLORS.GREY_600};
`;

export const InputErrorMessage = customStyled(Text)`
  font-weight: 500;
  font-size: 12px;
  line-height: 10px;
  color: ${COLORS.DARK_PINK};
`;

export const InputBox = customStyled(Input)`
  width: 140px;
  height: 36px;
`;

export const SwitchLayout = customStyled(Switch)`
  input + div:before {
    width: 44px;
    height: 26px;
    border-radius: 12px;
    opacity: 1;
    background: ${COLORS.GRAY};
  }
  input + div:after {
    width: 23px;
    height: 23px;
    top: 50%;
    box-shadow: none;
    border 1px solid rgba(0,0,0,.2);
    background: white;
    left: 1px;
  }
  input:checked + div:after {
    transform: translate(50%, -50%);
    left: 9px;
  }

  input:checked + div:before {
    background: ${COLORS.BLUE};
  }

  input {
    height: 23px;
    width: 46px;
  }

`;
